import axios from 'axios';
import * as apiURL from './apiConfig';

export const addMedia = async (data, { params = '' }) => {
  let formData = new FormData();
  formData.append('file', data);
  /*for (let key in data) {
    formData.append(key, data[key]);
  }*/
  try {
    const response = await axios.post(
      `${apiURL.MEDIA_URL}${params}`,
      formData,
      {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
